import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { CodeIcon } from "../../../assets/images/icons/CodeIcon";
import { POSTHOG_EVENTS } from "../../../constants/PostHogEvents";
import usePostHog from "../../../hooks/usePostHog";
import { PlaygroundImage } from "../../../models/playground";
import ApiReferenceDialog from "../ApiReferenceDialog/ApiReferenceDialog";
import BriaButton from "../BriaButton/BriaButton";
import BriaTooltip from "../BriaTooltip/BriaTooltip";
import styles from "./ApiReferenceButton.module.scss";

export interface ApiReferenceButtonProps {
	image: PlaygroundImage;
	tooltip?: string;
	className?: string;
}

const ApiReferenceButton = ({ image, tooltip = "View API Reference", className }: ApiReferenceButtonProps) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { trackEvent } = usePostHog();

	const handleOpenDialog = (e: React.MouseEvent<HTMLButtonElement | SVGElement>) => {
		e.stopPropagation();
		trackEvent(POSTHOG_EVENTS.API_REFERENCE_DIALOG_OPENED);
		setIsDialogOpen(true);
	};

	const handleCloseDialog = (e: React.MouseEvent<HTMLButtonElement | SVGElement>) => {
		e.stopPropagation();
		trackEvent(POSTHOG_EVENTS.API_REFERENCE_DIALOG_CLOSED);
		setIsDialogOpen(false);
	};

	return (
		<>
			<BriaTooltip title={tooltip}>
				<BriaButton
					buttonType="tertiaryMedium"
					className={clsx(styles.apiButton, styles.iconButton, className, {
						["iconHover"]: true,
					})}
					onClick={handleOpenDialog}
				>
					<CodeIcon />
				</BriaButton>
			</BriaTooltip>

			<ApiReferenceDialog open={isDialogOpen} onClose={handleCloseDialog} image={image} />
		</>
	);
};

export default observer(ApiReferenceButton);
